import baseStyles from './widget.css';
import resultsRedesignStyles from './results-redesign.css';
import responsiveStyles from './responsive.css';
import reducedMotionStyles from './reduced-motion.css';

const widgetStyles = [
  baseStyles,
  resultsRedesignStyles,
  responsiveStyles,
  reducedMotionStyles,
].join('\n');

export default widgetStyles;
